import TeacherSalaryAudit from './src/main';

/* istanbul ignore next */
TeacherSalaryAudit.install = function(Vue) {
  Vue.component(TeacherSalaryAudit.name, TeacherSalaryAudit);
};

export default TeacherSalaryAudit;
